/**
 * @file コンポーネント：フル動画ページ関連症例 DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { OperationSlider } from "~/src/components/projects/OperationSlider";

// スタイル読み込み
import {
    StyledSection,
    StyledSectionContents,
    StyledSectionHeader,
    StyledSectionHeaderButton,
    StyledSectionHeaderText,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <>
            {props.operationlist.length > 0 && (
                <StyledSection>
                    <StyledSectionHeader>
                        <StyledSectionHeaderText>
                            {props.headline}
                        </StyledSectionHeaderText>
                        <StyledSectionHeaderButton
                            onClick={() => props.setIsOpen(!props.isOpen)}
                        >
                            {props.isOpen === true ? (
                                <i className="fas fa-chevron-up"></i>
                            ) : (
                                <i className="fas fa-chevron-down"></i>
                            )}
                        </StyledSectionHeaderButton>
                    </StyledSectionHeader>
                    <StyledSectionContents
                        className={props.isOpen && "is-open"}
                    >
                        <OperationSlider
                            list={props.operationlist}
                            sliderId={props.sliderId}
                        />
                    </StyledSectionContents>
                </StyledSection>
            )}
        </>
    );
};
